import VCard from "vcard-creator";
import { saveAs } from "file-saver";

const getPhoneValue = (person, fieldName, prefixFieldName) => {
  const phone = person?.[fieldName] || "";
  const prefix = person?.[prefixFieldName] || "";

  if (!phone) {
    return "";
  }

  return phone.trim().startsWith("+") || !prefix ? phone : `${prefix}${phone}`;
};

const createVcj = (person) => {
  console.log(person);
  const vCard = new VCard();
  const hasPlusPlan = person?.plan === "plus";

  vCard.addName(person.lastName, person.firstName);

  if (hasPlusPlan && person.companyName) {
    vCard.addCompany(person.companyName);
  }

  if (person.email) {
    vCard.addEmail(person.email, "PREF;WORK");
  }

  if (
    hasPlusPlan &&
    person.companyEmail &&
    person.companyEmail !== person.email
  ) {
    vCard.addEmail(person.companyEmail, "WORK");
  }

  // if (person.pec) {
  //   vCard.addEmail(person.pec, "PREF;WORK");
  // }

  if (person.mobile) {
    vCard.addPhoneNumber(getPhoneValue(person, "mobile", "mobilePrefix"), "PREF;WORK");
  }

  if (hasPlusPlan && person.phone) {
    vCard.addPhoneNumber(getPhoneValue(person, "phone", "phonePrefix"));
  }

  if (hasPlusPlan && person.website) {
    vCard.addURL(person.website);
  }

  (function () {
    const vcardString = vCard.toString();
    const blob = new Blob([vcardString], { type: "text/vcard;charset=utf-8" });
    
    // Check if on iOS Safari
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (isIOS) {
      // For iOS, create a data URL and open it directly
      const reader = new FileReader();
      reader.onloadend = function() {
        const url = reader.result;
        // Create a temporary link
        const link = document.createElement('a');
        link.href = url;
        link.download = `${person.firstName}${person.lastName}.vcf`;
        link.setAttribute('target', '_blank');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      reader.readAsDataURL(blob);
    } else {
      // For other browsers, use the standard download
      saveAs(blob, `${person.firstName}${person.lastName}.vcf`);
    }
  })();
};
export default createVcj;
